import fetch from './index';

async function request(method, url, param) {
    let isError = false;
    const data = await fetch.fetch(method, url, param).catch((error) => { isError = true; return error; });
    return { data, isError };
}

export function get({url, param = null}) {
    return request('GET', url, param);
}

export function post({url, param = null}) {
    return request('POST', url, param);
}

// PUT 全部更新
export function put({url, param = null}) {
    return request('PUT', url, param);
}

// PATCH 局部更新
export function patch({url, param = null}) {
    return request('PATCH', url, param);
}

export function del({url, param = null}) {
    return request('DELETE', url, param);
}



// WEBPACK FOOTER //
// ./src/api/request.js